import { connect } from 'react-redux';

// import { getOrganizationMembersList } from '../../../Projects/projectsActions';
import {
  clearOfficeDetails,
  createOffice,
  updateOffice,
} from '../officesActions';
import OfficeDetails from './OfficeDetails';

const mapStateToProps = state => ({
  // orgMembersList: state.project.orgMembersList,
  // memberListIsLoading: state.project.memberShortListIsLoading,

  addOrUpdateOfficeLoading: state.office.addOrUpdateOfficeLoading,
  officeDetails: state.office.officeDetails,
  officeCreateUpdateSuccess: state.office.officeCreateUpdateSuccess,
});

const mapDispatchToProps = dispatch => ({
  // getOrganizationMembersList: payload =>
  //   dispatch(getOrganizationMembersList(payload)),
  createOffice: payload => dispatch(createOffice(payload)),
  updateOffice: payload => dispatch(updateOffice(payload)),
  clearOfficeDetails: () => dispatch(clearOfficeDetails()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OfficeDetails);
